import * as i from "react";
function a(c, d, s, f) {
  var n = i.useRef(null);
  n.current = {
    open: d,
    triggerOpen: s,
    customizedTrigger: f
  }, i.useEffect(function() {
    function u(r) {
      var o;
      if (!((o = n.current) !== null && o !== void 0 && o.customizedTrigger)) {
        var e = r.target;
        e.shadowRoot && r.composed && (e = r.composedPath()[0] || e), n.current.open && c().filter(function(t) {
          return t;
        }).every(function(t) {
          return !t.contains(e) && t !== e;
        }) && n.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", u), function() {
      return window.removeEventListener("mousedown", u);
    };
  }, []);
}
export {
  a as default
};
//# sourceMappingURL=useSelectTriggerControl.mjs.map
